import React from 'react';
import { Button } from 'antd';
import { SetupFailureModal } from './styles';
import { withTranslation } from 'react-i18next';
import { SETUP_ERROR_MODAL } from './translationValues';

const NAMESPACE = ['SETUP_ERROR_MODAL'];

const SetupErrorModal = ({ t, showError, setShowError }) => {
  return (
    <SetupFailureModal
      visible={showError}
      footer={
        <Button onClick={() => setShowError(false)}>
          {t(SETUP_ERROR_MODAL.CLOSE_BUTTON.key, SETUP_ERROR_MODAL.CLOSE_BUTTON.value)}
        </Button>
      }
      centered
      onCancel={() => setShowError(false)}
      closable={false}
    >
      <p>{t(SETUP_ERROR_MODAL.ERROR_MESSAGE.key, SETUP_ERROR_MODAL.ERROR_MESSAGE.value)}</p>
    </SetupFailureModal>
  );
};

export default withTranslation(NAMESPACE)(SetupErrorModal);
